import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { collectSobDataDependsOnSettings } from '../../competitorsSob/helpers/collectSobDataDependsOnSettings'

import { selectQbrState } from './selectQbrState'

export const selectQbrPersonalSystemsSobCompetitorsDependOnSettings = createSelector(
  [selectQbrState],
  ({ selectedDocument, documentSettings }) => {
    if (!selectedDocument) {
      return []
    }

    const sobCompetitors = selectedDocument.SobCompetitors[ProgramTypes.PersonalSystems] || []
    const netNdp = documentSettings.netNdp
    const currency = documentSettings.currency
    const rounding = documentSettings.rounding
    return collectSobDataDependsOnSettings({ sobCompetitors, netNdp, currency, rounding })
  }
)
